import { combineReducers } from '@ynap/reducer-utils';
import * as reducers from './reducers';

const userReducer = combineReducers({ ...reducers });

export default userReducer;
